import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
export const gradeOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: true,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "团队等级名称",
            prop: "gradeName",
            type: "input",
            search: true
        },
        {
            label: "团队人数",
            prop: "number",
            type: "input"
        },
        {
            label: "团队最低经验值",
            prop: "minSuffer",
            type: "input",
            formsolt: true
        },
        {
            label: "团队最高经验值",
            prop: "maxSuffer",
            type: "number"
        }
    ]
};